import React, { useLayoutEffect, useState } from 'react';
import { styled, Box } from '@mui/material';
import { omit } from 'lodash-es';
import { ThemeProvider } from './ThemeProvider';
import { globalThemeEvent, updateGlobalThemeMode, switchGlobalThemeMode, updateGlobalLocaleKey, getGlobalZoomUI, updateGlobalZoomUI, resetGlobalZoomUI, getGlobalThemeMode, defineGlobalLocale, } from './globalThemeEvent';
import { completeObject } from '../../Shared/complete';
import { getDefaultZoomUI } from './zoomUI';
const StyledGlobalThemeBox = styled(Box)((props) => {
    const { theme } = props;
    const zoomUI = theme.zoomUI ?? getDefaultZoomUI();
    let semantic = zoomUI.semantic.light;
    if (theme?.palette?.mode === 'dark') {
        semantic = zoomUI.semantic.dark;
    }
    const style = {
        color: semantic.text.stronger.neutral,
        background: semantic.bg.default,
    };
    return style;
});
const GlobalThemeBox = (props) => {
    const restProps = omit(props, 'component');
    return React.createElement(StyledGlobalThemeBox, { ...restProps });
};
const GlobalThemeProvider = (props) => {
    const { children, defaultMode } = props;
    const defaultZoomUI = getGlobalZoomUI();
    const [dynamicZoomUI, setDynamicZoomUI] = useState({
        ...defaultZoomUI,
    });
    const [dynamicMode, setDynamicMode] = useState(() => defaultMode ?? getGlobalThemeMode());
    useLayoutEffect(() => {
        // set default global theme mode
        updateGlobalThemeMode(defaultMode ?? getGlobalThemeMode());
        globalThemeEvent.on('updateThemeMode', (updatedMode) => {
            setDynamicMode(updatedMode);
        });
        globalThemeEvent.on('defineLocale', (map) => {
            const cacheZoomUI = getGlobalZoomUI();
            const updatedZoomUI = { ...cacheZoomUI, localeMap: map };
            setDynamicZoomUI(updatedZoomUI);
        });
        globalThemeEvent.on('updateLocaleKey', (updatedKey) => {
            const cacheZoomUI = getGlobalZoomUI();
            const updatedZoomUI = { ...cacheZoomUI, ...{ localeKey: updatedKey } };
            setDynamicZoomUI(updatedZoomUI);
        });
        globalThemeEvent.on('updateZoomUI', (zoomUI) => {
            const cacheZoomUI = getGlobalZoomUI();
            const updatedZoomUI = completeObject(zoomUI, cacheZoomUI);
            setDynamicZoomUI(updatedZoomUI);
        });
        globalThemeEvent.on('resetZoomUI', () => {
            const cacheZoomUI = getDefaultZoomUI();
            setDynamicZoomUI(cacheZoomUI);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(ThemeProvider, { mode: dynamicMode, zoomUI: dynamicZoomUI }, children));
};
GlobalThemeProvider.updateMode = updateGlobalThemeMode;
GlobalThemeProvider.switchMode = switchGlobalThemeMode;
GlobalThemeProvider.defineLocale = defineGlobalLocale;
GlobalThemeProvider.updateLocale = updateGlobalLocaleKey;
GlobalThemeProvider.updateZoomUI = updateGlobalZoomUI;
GlobalThemeProvider.resetZoomUI = resetGlobalZoomUI;
GlobalThemeProvider.Box = GlobalThemeBox;
export { GlobalThemeProvider };
